import React, {Component} from 'react';
import {MemoryRouter, Route, Routes, Link} from 'react-router-dom';



class ConditionalMemoryRouter extends Component {
    
    render() {
        if(this.props.renderWithRouter){
            return <MemoryRouter>
                {this.props.children}
            </MemoryRouter>
        }else{
            return <MemoryRouter>
                {this.props.children}
            </MemoryRouter>
        }

    }




}

export default ConditionalMemoryRouter;



// WEBPACK FOOTER //
// ./src/components/ConditionalMemoryRouter.jsx